import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/index.css';
import notify_util from './mixin/notifyjs'
import util from './mixin/utiljs'

import cognito from './cognito'
import Vuelidate from 'vuelidate'
import "./assets/scss/b-pager.css";
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import moment from 'moment-timezone'
import wysiwyg from "vue-wysiwyg";
import "vue-wysiwyg/dist/vueWysiwyg.css";
import Multiselect from 'vue-multiselect'
import firebase from 'firebase'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const config = {
    apiKey: process.env.VUE_APP_FIREBASE_APIKEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTHDOMAIN,
    // databaseURL: process.env.VUE_APP_AWS_POOLS_ID,
    projectId: process.env.VUE_APP_FIREBASE_PROJECTID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGEING_SENDER_ID,
    appId: process.env.VUE_APP_FIREBASE_MESSAGEING_APP_ID,
    measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
}
firebase.initializeApp(config);


moment.tz.setDefault('Asia/Tokyo')
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
Vue.config.productionTip = false
Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.use(VueToast);
Vue.use(Vuelidate)
Vue.mixin(notify_util)
Vue.mixin(util)
Vue.use(VueSweetalert2);
Vue.use(wysiwyg, {});
Vue.component('multiselect', Multiselect)

new Vue({
  router,
  store,
  cognito,
  icons,
  render: h => h(App)
}).$mount('#app')
